export default "__VITE_ASSET__DqDCfW3O__";